import { makeStyles } from 'tss-react/mui';
import { colors, spacing, typographySohne } from '../../styles/jss/variables';
import { minHeights } from '../../styles/jss/common';
import { getHeadingColor } from '../../styles/jss/utils';
export const getMinHeightStyles = (theme, minHeights, sizeKey) => ({
    minHeight: '335px',
    [theme.breakpoints.up('sm')]: {
        minHeight: minHeights[sizeKey].sm,
    },
    [theme.breakpoints.up('md')]: {
        minHeight: minHeights[sizeKey].md,
    },
    [theme.breakpoints.up('lg')]: {
        minHeight: minHeights[sizeKey].lg,
    },
    [theme.breakpoints.up('xl')]: {
        minHeight: minHeights[sizeKey].xl,
    },
});
const useStyles = makeStyles()((theme, _params, classes) => {
    var _a;
    return ({
        heading: Object.assign(Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.large_bold_sm), { color: colors.supplementary.black, [theme.breakpoints.between('sm', 'xl')]: {
                color: colors.supplementary.white,
            }, [theme.breakpoints.up('md')]: Object.assign(Object.assign(Object.assign({}, theme.typography.xxl_bold), theme.typographySpacing.xxl_bold_lg), { color: colors.supplementary.white }), [theme.breakpoints.up('xl')]: Object.assign(Object.assign(Object.assign({}, theme.typography.xxxxl), theme.typographySpacing.xxxxl_sm), { color: colors.supplementary.white }) }),
        subheading: {
            color: colors.supplementary.black,
            [theme.breakpoints.up('md')]: {
                color: colors.supplementary.white,
            },
        },
        message: {
            color: colors.supplementary.white,
        },
        link: {
            width: '100%',
            display: 'flex',
            '&  :focus-visible': {
                outline: 0,
                outlineOffset: 0,
            },
            [theme.breakpoints.up('sm')]: {
                width: '50%',
                margin: 0,
                '& button': { width: '100%' },
                '&:not(:last-child)': {
                    marginBottom: '0',
                    marginRight: spacing.medium,
                },
            },
            [theme.breakpoints.up('md')]: {
                width: '46%',
            },
            '& button': {
                flexGrow: 1,
            },
        },
        linkContainer: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                flexDirection: 'row',
                maxWidth: '650px',
                display: 'flex',
                gap: 0,
                [`& .${classes.link}`]: {
                    width: '50%',
                    margin: 0,
                    '& button': { width: '100%' },
                },
                '& > :first-child': {
                    marginBottom: 0,
                    marginRight: spacing.medium,
                },
            },
        },
        outsideLinkContainer: {
            marginLeft: '20px',
            marginRight: '20px',
            display: 'block',
            marginTop: spacing.small,
            [theme.breakpoints.up('sm')]: {
                display: 'none',
            },
            '& > :first-child': {
                marginBottom: spacing.small,
                marginRight: 0,
            },
        },
        homeVideoContainer: {
            justifyContent: 'start',
        },
        outsideShowTrustpilotWidget: {
            minHeight: '60px',
            display: 'flex',
            marginTop: spacing.small,
            marginLeft: '20px',
            marginRight: '20px',
            padding: '18px',
            justifyContent: 'center',
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
        headingLine: {
            padding: 0,
            alignSelf: 'flex-start',
            display: 'block',
        },
        wrapHeading: {
            textAlign: 'left',
        },
        contentInner: {
            width: '100%',
            margin: spacing.medium,
            [theme.breakpoints.up('sm')]: {
                margin: `${spacing.small} ${spacing.medium}`,
            },
            [theme.breakpoints.up('md')]: {
                margin: `${spacing.medium} ${spacing.large}`,
            },
        },
        fontSohne: {
            [`& .${classes.heading}`]: Object.assign(Object.assign(Object.assign({}, typographySohne.large_bold), theme.typographySpacing.large_bold_sm), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, typographySohne.xxl_bold), theme.typographySpacing.xxl_bold_sm), [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.xxxxl), theme.typographySpacing.xxxxl_sm) }),
            [`& .${classes.newMessage}`]: Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.none), { textAlign: 'left', color: colors.supplementary.white, [theme.breakpoints.up('sm')]: Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.small_bold_lg), [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.medium_regular), theme.typographySpacing.medium_regular_sm) }),
        },
        newMessage: {},
        content: {
            width: '100%',
            alignSelf: 'start',
            position: 'absolute',
            [theme.breakpoints.up('sm')]: {
                width: '75%',
            },
            [theme.breakpoints.up('xl')]: {
                width: '50%',
            },
        },
        // We need to override the default positioning of Content Container
        homeVideoMobileContent: {
            height: '100%',
        },
        container: {
            // For full width image to position against
            position: 'relative',
            display: 'flex',
            // Mobile - image below content
            flexDirection: 'column-reverse',
            placeContent: 'center',
            overflow: 'hidden',
            '& video': {
                display: 'block',
                position: 'absolute',
                width: '100%',
                height: '100%',
                left: 0,
                top: 0,
                objectFit: 'cover',
            },
        },
        mobilePositionBottom: {
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
            },
        },
        removeMarginBottom: {
            [theme.breakpoints.down('sm')]: {
                marginBottom: spacing.medium,
                marginTop: spacing.small,
                marginLeft: '20px',
                marginRight: '20px',
            },
        },
        headingColor: {
            color: getHeadingColor((_a = _params === null || _params === void 0 ? void 0 : _params.textColour) !== null && _a !== void 0 ? _a : ''),
        },
        adjustMessage: {
            marginBottom: 0,
            [theme.breakpoints.up('sm')]: {
                marginBottom: spacing.xs,
                textAlign: 'left',
            },
        },
        videoContainer: {
            width: '100%',
            position: 'relative',
            // Make square on mobile
            paddingTop: '100%',
            [theme.breakpoints.up('xs')]: {
                // Use min heights on tablet up
                paddingTop: 0,
            },
            // backup  image min height if other min heights not used
            minHeight: '200px',
        },
        minHeightLarge: {
            [`&, & .${classes.videoContainer}`]: Object.assign({}, getMinHeightStyles(theme, minHeights, 'LARGE')),
        },
    });
});
export default useStyles;
